// Field schemas for the admin content editors.
export const SCHEMAS = {
  products: {
    label: "Products",
    singular: "Product",
    fields: [
      { key: "name", label: "Name", type: "text" },
      { key: "price", label: "Price (USD)", type: "number" },
      { key: "category", label: "Category", type: "select", options: ["Hoodies", "Long Sleeve", "T-Shirts"] },
      { key: "image", label: "Image", type: "image" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "published", label: "Published (visible in store)", type: "checkbox" },
    ],
    columns: ["name", "price", "category", "published"],
  },
  blog: {
    label: "Blog",
    singular: "Post",
    fields: [
      { key: "title", label: "Title", type: "text" },
      { key: "slug", label: "Slug (URL)", type: "text" },
      { key: "category", label: "Category", type: "text" },
      { key: "author", label: "Author", type: "text" },
      { key: "readTime", label: "Read time", type: "text" },
      { key: "image", label: "Cover image", type: "image" },
      { key: "excerpt", label: "Excerpt", type: "textarea" },
      { key: "body", label: "Body (blank line between paragraphs)", type: "paragraphs" },
    ],
    columns: ["title", "category", "author"],
  },
  tutorials: {
    label: "Tutorials",
    singular: "Tutorial",
    fields: [
      { key: "title", label: "Title", type: "text" },
      { key: "category", label: "Category", type: "text" },
      { key: "gif", label: "Demo GIF/Image", type: "image" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "steps", label: "Steps (one per line)", type: "lines" },
    ],
    columns: ["title", "category"],
  },
  faqs: {
    label: "FAQs",
    singular: "FAQ Group",
    fields: [
      { key: "category", label: "Group heading", type: "text" },
      { key: "items", label: "Q&A (one per line as: Question :: Answer)", type: "faqitems" },
    ],
    columns: ["category"],
  },
};

// Convert a stored doc -> flat form values (arrays become text).
export function toForm(doc, fields) {
  const f = {};
  for (const field of fields) {
    const v = doc[field.key];
    if (field.type === "paragraphs") f[field.key] = Array.isArray(v) ? v.join("\n\n") : v || "";
    else if (field.type === "lines") f[field.key] = Array.isArray(v) ? v.join("\n") : v || "";
    else if (field.type === "faqitems")
      f[field.key] = Array.isArray(v) ? v.map((i) => `${i.q} :: ${i.a}`).join("\n") : v || "";
    else if (field.type === "checkbox") f[field.key] = !!v;
    else f[field.key] = v ?? "";
  }
  return f;
}

// Convert form values -> stored doc (text becomes arrays, price numeric).
export function fromForm(form, fields) {
  const out = {};
  for (const field of fields) {
    const v = form[field.key];
    if (field.type === "paragraphs")
      out[field.key] = String(v || "").split(/\n\s*\n/).map((s) => s.trim()).filter(Boolean);
    else if (field.type === "lines")
      out[field.key] = String(v || "").split("\n").map((s) => s.trim()).filter(Boolean);
    else if (field.type === "faqitems")
      out[field.key] = String(v || "").split("\n").map((s) => s.trim()).filter(Boolean).map((line) => {
        const [q, ...rest] = line.split("::");
        return { q: (q || "").trim(), a: rest.join("::").trim() };
      });
    else if (field.type === "number") out[field.key] = parseFloat(v) || 0;
    else if (field.type === "checkbox") out[field.key] = !!v;
    else out[field.key] = v;
  }
  return out;
}
